import { render } from "./TemplateD.vue?vue&type=template&id=cefbf632"
import script from "./TemplateD.vue?vue&type=script&lang=js"
export * from "./TemplateD.vue?vue&type=script&lang=js"
script.render = render

export default script